export default __webpack_public_path__ + "static/media/237.0fcabb30.svg";